import Phaser from 'phaser';

export default class PauseScene extends Phaser.Scene {
  constructor() {
    super({ key: 'PauseScene' });
  }

  create() {
    const { width, height } = this.cameras.main;

    // Dim overlay
    const overlay = this.add.rectangle(width / 2, height / 2, width, height, 0x000000, 0.7);

    // Pause menu container
    const menuBg = this.add.rectangle(width / 2, height / 2, 300, 350, 0x1A1A1A);
    menuBg.setStrokeStyle(2, 0xFFD700);

    // Title
    this.add.text(width / 2, height / 2 - 140, 'PAUSED', {
      font: 'bold 32px Playfair Display',
      fill: '#FFD700'
    }).setOrigin(0.5);

    // Menu options
    const menuItems = [
      { text: 'RESUME', action: () => this.resume() },
      { text: 'INVENTORY', action: () => console.log('Inventory') },
      { text: 'MAP', action: () => console.log('Map') },
      { text: 'SAVE GAME', action: () => this.saveGame() },
      { text: 'OPTIONS', action: () => console.log('Options') },
      { text: 'QUIT TO TITLE', action: () => this.quitToTitle() }
    ];

    menuItems.forEach((item, index) => {
      const y = height / 2 - 80 + index * 45;
      const button = this.add.text(width / 2, y, item.text, {
        font: '20px Manrope',
        fill: '#FFFFFF'
      }).setOrigin(0.5).setInteractive({ useHandCursor: true });

      button.on('pointerover', () => {
        button.setStyle({ fill: '#FFD700' });
      });

      button.on('pointerout', () => {
        button.setStyle({ fill: '#FFFFFF' });
      });

      button.on('pointerdown', item.action);
    });

    // ESC to resume
    this.input.keyboard.on('keydown-ESC', () => this.resume());
  }

  resume() {
    this.scene.resume('GameScene');
    this.scene.stop();
  }

  saveGame() {
    // Get game state from registry
    const gameState = {
      faction: this.registry.get('playerFaction'),
      class: this.registry.get('playerClass'),
      savedAt: new Date().toISOString()
    };

    localStorage.setItem('anunnakiSave', JSON.stringify(gameState));

    // Show save confirmation
    const text = this.add.text(this.cameras.main.width / 2, this.cameras.main.height / 2 + 120, 
      'Game Saved!', {
      font: '16px Manrope',
      fill: '#4CAF50'
    }).setOrigin(0.5);

    this.time.delayedCall(1500, () => text.destroy());
  }

  quitToTitle() {
    this.scene.stop('GameScene');
    this.scene.start('TitleScene');
  }
}
